(function () {
	const initCollapsibleColumn = () => {
		$(".accordion-heading").unbind("click").on("click", function () {
			const parent = $(this).parent();

			if (!parent.hasClass("active")) {
				parent
					.siblings(".accordion-column.active")
					.removeClass("active");
				parent.addClass("active");
				$(this)
					.closest(".image-with-text__columns")
					.find(".accordion-content")
					.stop()
					.slideUp(300);
				$(this).next().stop().slideDown(300);
			} else {
				parent
					.siblings(".accordion-column.active")
					.removeClass("active");
				parent
					.closest(".image-with-text__columns")
					.find(".accordion-content")
					.stop()
					.slideUp(300);
				parent.removeClass("active");
				$(this).next().stop().slideUp(300);
			}
		});
	};

	document.addEventListener("shopify:section:load", function () {
		initCollapsibleColumn();
	});

	initCollapsibleColumn();
})();
